import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SmsService } from 'src/app/services/sms-service/smsservice';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SMSBasic } from 'src/app/models/turns-models/turns-sms-basic.model';

@Component({
  selector: 'app-sms-smss-breadcrumb-filter-card',
  templateUrl: './sms-smss-breadcrumb-filter-card.component.html',
  styleUrls: ['./sms-smss-breadcrumb-filter-card.component.scss']
})
export class SmsSmssBreadcrumbFilterCardComponent implements OnInit {

  // @Input() smss;
  // centers;
  // centersForm = new FormGroup({});

  constructor(
    // private smsDesksTurnsService: SmsService,
    // private userStorageService: UserStorageService
              ) { }

  ngOnInit() {
    // this.getCenters();
    // if (this.userStorageService.getFilterNotifications()) {
    //   this.centersForm.patchValue(this.userStorageService.getFilterNotifications()['centersForm']);
    // }
    // this.filter();
  }

  // public updateCheckbox(form, reset?) {
  //   this._toggleCheckboxes(form, reset);
  // }

  // private _toggleCheckboxes(form, reset) {
  //   if (reset && form.get('all').value) {
  //     Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
  //   } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
  //     form.get('all').setValue(false);
  //   } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
  //     form.get('all').setValue(true);
  //   }
  //   this.userStorageService.setFilterNotifications({ centersForm: this.centersForm.getRawValue() });
  //   if (this.userStorageService.getFilterNotifications()['centersForm']['all']) {
  //     this.userStorageService.deleteFilterNotifications();
  //   }
  //   this.filter();
  // }

  // private getCenters() {
  //   const centers = new Array<string>();
  //   this.centersForm.addControl('all', new FormControl(true));
  //   this.smss.forEach((d: SMSBasic) => {
  //     if (centers.indexOf(d.CenterName) === -1) {
  //       centers.push(d.CenterName);
  //       this.centersForm.addControl(d.CenterName, new FormControl(false));
  //     }
  //   });
  //   this.centers = centers;
  // }

  // public filter() {
  //   const forms = {
  //     centersForm:
  //     {
  //       attribute: 'CenterName',
  //       values: []
  //     }
  //   };
  //   if (this.centersForm.get('all').value) {
  //     forms['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
  //   } else {
  //     Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { forms['centersForm'].values.push(c[0]); }});
  //   }
  //   this.smsDesksTurnsService.filterSms(forms);
  // }
}
